module.exports = "https://static.wanderu.com/static/media/chiku-hearts.6dbc6dd3.png";